<template>
  <div>
    <Navbar v-if="anthenticated">
      <template v-slot:mian_con>
        <router-view></router-view>
      </template>
    </Navbar>
    <div class="content_div" v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Navbar from './Base/Navbar'
import Utility from '@/components/mixin.js'
export default {
  name: 'navbar',
  components: {
    Navbar
  },
  mixins: [Utility],
  data() {
    return {
      anthenticated: true
    }
  },
  created() {
    let flag = localStorage.getItem('Flag')
    if (flag === 'true') {
      this.anthenticated = true
    } else {
      this.$router.push('/login')
    }
  }
}
</script>

<style>
a {
  color: inherit;
}
.el-dialog {
  max-height: 80% !important;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.el-dialog__body {
  height: 90%;
  overflow-x: hidden;
  overflow-y: auto !important;
}
.el-dialog__footer {
  border-top: 1px solid #dee2e6;
}
.el-select {
  display: block !important;
}
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}
::-webkit-scrollbar-track {
  background-color: #f5f5f5;
  border-radius: 4px;
}
::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: #c6c6c6;
}
</style>
